<template>
  <div id="app">
    <img src="../../../static/img/bg_callus.jpg" class="img_bg" />
    <div class="container">
      <div class="title">
        {{language=='zh'?detail.title:detail.titleEn}}
      </div>
      <div class="time">
        {{detail.activityTime}}
      </div>
      <div class="content editor-content-view" v-html="language=='zh'?detail.content:detail.contentEn">
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        detail:{},
      }
    },
    watch:{   //监听路由变化
      $route( to , from ){   
        if(to.fullPath.indexOf('NewsDetail') >= 0){
          this.getInfo()
        }
      }
    },
    props: {
      language: {
        type: String,
        default: ''
      }
    },
    mounted() {
      this.getInfo()
    },
    methods: {
      getInfo() {
        this.$http
          .get("/hdbs/api/activity/info/"+window.location.href.split("?id=")[1], {

          })
          .then(
            function (response) {
              var status = response.data.code;
              if (status === 0) {
                this.detail = response.data.data
              }
            }.bind(this)
          )
      },
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
.img_bg {
  margin-top: calc(-65px - 6vh);
  object-fit: cover;
  width: 100%;
}
.content{
  font-family: Regular;
}
.container
  padding: 10vh 20rem;
  margin:0 auto;
  .title
    text-align: center;
    font-size: 26px;
    color #024580
    font-family: Demibold;
  .time
    padding: 2vh 0;
    text-align: center;
    font-size: 14px;
    color:#606266
@media screen and (max-width: 1200px) {
.container{
  padding: 1rem;
}
}
</style>


// WEBPACK FOOTER //
// src/components/News/NewsDetail.vue